import {uniqueUuid} from "@vesta/unique/unique";

/** Bump the affected collection after updating its master data; deploy Pluto and Neptune together. */
export const GEOGRAPHY_MASTER_REVISIONS = {
    countries: uniqueUuid`2f521383-a803-4526-9590-01b90be50d7f`,
    indiaCities: uniqueUuid`4b4a5098-1db1-432f-b6c0-0c6e68cf0baf`,
    indiaPincodes: uniqueUuid`6d40605a-891e-4cb0-a80b-2780560aacde`,
    indiaStates: uniqueUuid`16ce1eff-7a6a-4036-98bd-b197dedd7d71`,
    indiaZones: uniqueUuid`5537ecef-93fc-48be-bd26-997a36183748`,
} as const;
